<template>
  <div class="tablePage">
    <el-table
      stripe
      v-loading="loading"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="headCellStyle"
      :height="tableHeight"
      fixed="left"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        :label="$t('public.table_carrier_name')"
        prop="keycode"
        show-overflow-tooltip
        fixed="left"
        width="200px"
      >
        <template #default="{ row }">
          <el-tooltip>
            <span>{{ row['keycode'] }}</span>
            <template #content>
              {{ $t('public.table_arch') }}:{{ row.structureName }}
            </template>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column :label="$t('public.status')" prop="status" width="180">
        <template #default="{ row }">
          <el-tag
            v-if="statusMap[row.status]"
            :type="statusMap[row.status].type"
            size="small"
            effect="light"
          >
            <i :class="statusMap[row.status].icon" style="margin-right: 4px;"></i>
            {{ $t(statusMap[row.status].text) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column :label="$t('business.isTraceable')" prop="isTrace" width="120">
        <template #default="{ row }">
          <el-tag
            :type="row.isTrace ? 'success' : 'info'"
            size="small"
            effect="light"
          >
            {{ row.isTrace ? $t('business.traceable') : $t('business.untraceable') }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="sampleValue" width="300">
        <template #header>
          <span
            :title="
              $t(
                'integration.sampling_is_used_to_represent_an_overall_value_of_the_monitoring_point_within_the_monitoring_range'
              )
            "
            >{{ $t('public.sample_value') }}</span
          >
        </template>
        <template #default="{ row }">
          <div v-if="row.sampleValue">
            <SampleValueColumn
              swiper
              :key="Math.random()"
              :sample="JSON.parse(row.sampleValue)"
              :scopeName="row.scopeName"
              :keycode="row.keycode"
              :typeId="row.typeId"
              :carrierId="row.id"
              :carrierInfo="row"
            >
            </SampleValueColumn>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="scopeName"
        width="150"
        show-overflow-tooltip
        :label="$t('labelTitle.Range')"
        v-if="isSysAdmin"
      ></el-table-column>

      <!--      <el-table-column-->
      <!--        prop="structureName"-->
      <!--        :label="$t('public.table_arch')"-->
      <!--        show-overflow-tooltip-->
      <!--      ></el-table-column>-->
      <el-table-column
        prop="description"
        :label="$t('public.table_desc')"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        :label="$t('tableTitle.Operation')"
        width="120"
        align="center"
        fixed="right"
      >
        <template #default="{ row }">
          <!--<AlarmSwitch-->
          <!--  class="uk-margin-small-right"-->
          <!--  :alarmSwitch="row.alarm_switch"-->
          <!--  :related="row.alarm_bind"-->
          <!--  :sceneId="row.scene_id"-->
          <!--  :carrierType="row.typeId"-->
          <!--  :carrierIds="[row.id]"-->
          <!--  :getList="() => $emit('getListFn')"-->
          <!--&gt;</AlarmSwitch>-->
          <template v-for="item in tableBtn">
            <el-button
              :class="item.cls"
              :key="item.id"
              @click="handle(row, item.method)"
              type="text"
              size="small"
              :title="$t(item.title)"
              :icon="item.icon"
            ></el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!--<AlarmSwitchDialog></AlarmSwitchDialog>-->
  </div>
</template>

<script>
import { isCarrierAbnormalConvert, traceConvert } from '@/utils/convert'
import SampleValue from '@/components/SampleValue/SampleValue'
import SampleValueColumn from '@/components/SampleValueColumn/SampleValueColumn'
import Popover from '@/components/sampleProper/sampleProper'
import AlarmSwitch from '@/components/AlarmSwitch/AlarmSwitch.vue'
// import AlarmSwitchDialog from '@/components/AlarmSwitch/AlarmSwitchDialog.vue'

export default {
  props: ['loading', 'tableData', 'getCarrierStatus'],
  computed: {
    isSysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      return currentUser.sysScope && currentUser.sysAdmin
    }
  },
  components: {
    Popover,
    SampleValue,
    SampleValueColumn,
    // AlarmSwitch,
    // AlarmSwitchDialog
  },
  data () {
    return {
      traceConvert,
      isCarrierAbnormalConvert,
      statusMap: {
        0: { icon: 'iconfont icon-yunhang', text: 'carrier.run', type: 'success' },
        1: { icon: 'iconfont icon-beiyong', text: 'carrier.backup', type: 'info' },
        2: { icon: 'iconfont icon-baofei', text: 'carrier.retirement', type: 'danger' },
        3: { icon: 'iconfont icon-daixiugai', text: 'carrier.repaired', type: 'warning' },
        4: { icon: 'iconfont icon-chushuang', text: 'carrier.defrost', type: '' }
      },
      tableHeight: '100%',
      total: 0,
      flag: false,
      title: '',
      isShow: false,
      editForm: {
        id: null,
        status: null
      },
      statusArray: [],
      tableBtn: [
        {
          id: 1,
          title: 'buttonTitle.Details',
          icon: 'el-icon-tickets',
          method: 'detailFn',
          vHas: [''],
          isBtn: true
        },
        {
          id: 2,
          title: 'buttonTitle.Delete',
          icon: 'el-icon-delete',
          method: 'rowDel',
          vHas: ['incubatorDelCarrier'],
          isBtn: true
        }
      ],
      stautsIconArray: [
        'iconfont icon-yunhang',
        'iconfont icon-beiyong',
        'iconfont icon-baofei',
        'iconfont icon-daixiugai',
        'iconfont icon-chushuang'
      ]
    }
  },
  methods: {
    /** 表格隔行处理 */
    tableRowClassName ({ row }) {
      switch (row.status) {
        case 0: {
          return 'run-row'
        }
        case 1: {
          return 'fail-row'
        }
        case 2: {
          return 'beiyong-row'
        }
        case 3: {
          return 'daixiu-row'
        }
        case 4: {
          return 'chushuang-row'
        }
        default:
          break
      }
    },
    handleSelectionChange (arg) {
      this.$emit('choozeTableFn', arg)
    },
    handle (row, Fn) {
      this.$emit(Fn, row)
    },

    generJsonFn2 (sample_value, s) {
      if (!sample_value) return

      let str = ' '

      const { hum } = JSON.parse(sample_value)
      if (!hum) return
      // hum 湿度 temp 温度
      if (s === 'val') {
        str = hum.val + '%'
      } else {
        str = this.$timetransition(hum.time)
      }

      return str
    },
    isSHowTempFn (sample_value) {
      if (!sample_value) return false

      const { temp } = JSON.parse(sample_value)
      return temp
    },
    isSHowHumFn (sample_value) {
      if (!sample_value) return false

      const { hum } = JSON.parse(sample_value)
      return hum
    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
  height: calc(100% - 60px);

  i {
    color: #ccc;
  }

  .temp-class,
  .hum-class {
    height: 26px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .t-h-time {
      flex: 3;
      text-align: center;
      background-color: var(--primary-color);
      color: #ffffff;
      border-radius: 2px;
      font-size: 12px;
      border: 1px solid var(--primary-color);
      border-right: none;
      border-radius: 2px 0px 0px 2px;
    }

    .t-h-val {
      flex: 1;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
      border: 1px solid var(--primary-color);
      border-left: none;
      border-radius: 2px 0px 0px 2px;
    }
  }
}
</style>
